export const environment = {
  name: 'development',
  production: false,
  sentryActive: true,
  debug: true,
  apiBaseUrl: 'https://dev-pms.hoomvip.com/api',
  apiErrors: {
    customHandledStatuses: [401],
  },
  maxNavHistory: 50,
  defaultAppLang: 'es',
  defaultVideoLang: 'en',
  brandingCodeQueryParam: 'e',
  defaultClientDomainKey: 'hoomvip',
  defaultHost: 'dev-guest.hoomvip.com',
  defaultDomainSuffix: '-dev-guest.hoomvip.com',
  paymentLockTimeMinutes: 5,
};
